import React, { Component, PropTypes } from 'react'
import Link from 'gatsby-link'

import './index.scss'

class AHref extends Component {
  render () {
    const { children, url } = this.props

    return (
      <a href={url} target="_blank">
        {children}
      </a>
    )
  }
}

AHref.propTypes = {
  children: PropTypes.node.isRequired,
  url: PropTypes.string,
}

export default AHref



// WEBPACK FOOTER //
// ./src/components/AHref/index.js